export default __webpack_public_path__ + "static/Aziende-5579447517826b7e468a36b485a821d0.jpg";